import { render, staticRenderFns } from "./amenities.vue?vue&type=template&id=3a948ed4"
import script from "./amenities.vue?vue&type=script&lang=js"
export * from "./amenities.vue?vue&type=script&lang=js"
import style0 from "./amenities.vue?vue&type=style&index=0&id=3a948ed4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports